import { Button } from '@material-ui/core';
import React from 'react';
import Webcam from "react-webcam";

class WebcamCapture extends React.Component {
  state = {
    img: 'https://cdn.pixabay.com/photo/2016/08/20/05/38/avatar-1606916__340.png',
    webcamEnabled: false,
    textButton: 'הפעל מצלמה'
  };

  componentDidMount() {
    if (this.props.Img) {
      this.setState({
        textButton: 'צלם תמונה חדשה',
        img: this.props.Img
      });
    }
  }

  change = () => {
    const { webcamEnabled } = this.state;
    this.setState({
      webcamEnabled: !webcamEnabled,
      textButton: webcamEnabled ? 'צלם תמונה חדשה' : 'לחץ לצילום'
    });

    if (!webcamEnabled) return;
    this.capture();
  };

  setRef = webcam => {
    this.webcam = webcam;
  };

  capture = () => {
    const imageSrc = this.webcam.getScreenshot();
    this.setState({ img: imageSrc });
    this.props.changeImg(imageSrc);
  };

  getVideoConstraints = () => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    return {
      facingMode: isMobile ? { exact: "environment" } : "user", 
      width: { ideal: 640 },
      height: { ideal: 480 }
    };
  };

  render() {
    const { smallSize } = this.props;
    const isMobile = window.innerWidth <= 768;
    const size = smallSize
      ? { width: 130, height: 70 }
      : isMobile
        ? { width: 200, height: 130 }
        : { width: 400, height: 300 };

    return (
      <div className='WebcamCapture'>
        <div className='Webcam' style={{ width: size.width, height: size.height }}>
          {this.state.webcamEnabled ? (
            <Webcam
              audio={false}
              ref={this.setRef}
              screenshotFormat="image/jpeg"
              videoConstraints={this.getVideoConstraints()}
              style={{ width: '100%', height: '100%' }}
            />
          ) : (
            <img
              className='imgWebcam'
              src={this.state.img}
              alt='img'
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          )}
        </div>
        <Button
          variant="outlined"
          color="primary"
          onClick={this.change}
          size='small'
          style={{ marginTop: 5 }}
        >
          {this.state.textButton}
        </Button>
      </div>
    );
  }
}

export default WebcamCapture;
